// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about_wrapper__ngqnc","text":"about_text__Ncexu"};